<template>
    <div class="nav-2">
        <ul class="breadcrumb">
            <li>
                <router-link to="/">{{ $global.categories.home }}</router-link>
            </li>
            <li>
                <router-link to="home">
                    {{ $global.categories[$route.meta.category] }}
                </router-link>
            </li>
            <li v-if="$route.name !== $route.meta.category">
                <router-link :to="$route.name">
                    {{ $global.chapters[$route.meta.category][$route.name] }}
                </router-link>
            </li>
        </ul>
    </div>
</template>

<script>
export default {
    name: 'breadcrumb',
};
</script>

<style scoped lang="sass">
ul.breadcrumb
    padding: 0 16px
    list-style: none
    background-color: #eee
    position: fixed
    right: 1%
    border: 1px black solid

    li
        display: inline
        font-size: 14px

        & + li:before
            padding-left: 8px
            color: black
            content: "/\00a0"

        a
            color: rgb(224, 81, 32)
            text-decoration: none

            &:hover
                color: #01447e
                text-decoration: underline
</style>
